module.exports = __webpack_public_path__ + "0c3f94e8f85857f80b7d9848f3cef48b.pdf";